import avatar from "../../../assets/images/users/user-pic.jpg";

export const assets = {
  images: {
    avatar,
  },
};
